/**
 * @Author: qinyifang
 * @Date: 2025-04-28 14:34:18
 * @Description: 全局状态管理配置，初始化Pinia存储
 */
import { createPinia } from "pinia"
import piniaPersist from "pinia-plugin-persist"

const store = createPinia()
store.use(piniaPersist)
export default store
